import axios from 'axios';

import { addQueryParams, buildEndpoint, getAuthToken } from '@services/service';
import { Gateway } from '@app-types/payment.type';

const BASE_URL = process.env.REACT_APP_PAYMENTS_URL as string;

type Params = {
    isActive?: boolean;
};

const getGateways = async (params?: Params): Promise<Gateway[]> => {
    try {
        const queryParams = addQueryParams(params);
        const endpoint = buildEndpoint(BASE_URL, `/api/v1/gateways`);
        const response = await axios.get(`${endpoint}${queryParams}`, {
            headers: { Authorization: getAuthToken() },
        });
        return response.data.data;
    } catch (err) {
        console.error('Error getting all payment gateways:', err);
        return [];
    }
};

export { getGateways };
